import { _decorator, Component } from 'cc';
import NumberFormatter from '../../../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import TimeLabel from '../../../../../../common/scripts/Toolkit/Components/Misc/TimeLabel';
import IHistoryData from '../../../../../../tableEngine/Script/Game/Data/DataObject/History/IHistoryData';
import SimpleMachineInfo from '../../MachineInfo/SimpleMachineInfo';

const { ccclass, property } = _decorator;

enum EventType {
    CLOSE = 'CLOSE',
    OPEN_HISTORY_DETAIL = 'OPEN_HISTORY_DETAIL',
}

@ccclass('BaseHistoryRecord')
export default class BaseHistoryRecord extends Component {
    public static readonly EVENT_TYPE = EventType;

    @property(SimpleMachineInfo)
    protected readonly machineInfoLabel: SimpleMachineInfo = null;

    @property(TimeLabel)
    protected readonly timeLabel: TimeLabel = null;

    @property(NumberFormatter)
    protected readonly profitOrLossNumber: NumberFormatter = null;

    protected historyData: IHistoryData = null;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public display(data: IHistoryData, getDetail?: () => Promise<any>) {
        if (this.historyData === data) {
            return;
        }
        this.historyData = data;
        this.updateContent();
    }

    protected updateContent() {
        this.machineInfoLabel.updateInfo(this.historyData.machineID, this.historyData.machineName);
        this.timeLabel.time = this.historyData.timestamp;
        this.updateProfitOrLoss(this.historyData.win - this.historyData.bet);
    }

    protected updateProfitOrLoss(value: number) {
        this.profitOrLossNumber.value = value;
        // ensure the text display is updated, because the value may not be changed
        this.profitOrLossNumber.updateTextDisplay();
    }
}
